/* eslint-disable */
import React from 'react';
import {Form, Select,Button, Row, Col, Icon,Input,DatePicker} from 'antd';

const Search = Input.Search;
const { RangePicker } = DatePicker;

const Option = Select.Option;
class FormSearch extends React.PureComponent{
    render() {
        return(
            <div className="a-content--search-header search-default" id="list-search">
                <Row gutter={24}>
                    <Form className="a-form">
                        <Col lg={18} xl={17} xxl={18} className="search--left">
                            <Row gutter={{lg: 12, xl: 12, xxl: 24}}>
                                <Col lg={7} xl={6} xxl={4}>
                                    <Form.Item
                                        className="a-form__item search-content"
                                        label="Kho"
                                        labelCol={{span: 24}}>
                                        <Select className="a-select a-select--search-content"
                                                defaultValue="CNGZ">
                                            <Option value="CNGZ">CNGZ</Option>
                                            <Option value="SGHZ">SGHZ</Option>
                                            <Option value="HNUZ">HNUZ</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col lg={9} xl={7} xxl={5}>
                                    <Form.Item
                                        className="a-form__item search-content"
                                        label="Thời gian yêu cầu"
                                        labelCol={{span: 24}}>
                                        <RangePicker placeholder={['Bắt đầu', 'Kết thúc']}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={6} xl={7} xxl={6} className="search--right">
                            <Form.Item
                                className="a-form__item search-content item--special"
                                label="Mã kiện / Mã đơn / Khách hàng"
                                labelCol={{span: 24}}>
                                <Search
                                    className="a-input--search"
                                />
                            </Form.Item>
                            <div className="search--action">
                                <a href="#" className="link-reload "><Icon type="sync"/> Làm mới bộ lọc</a>
                                <Button type="primary" htmlType="submit"
                                        className="a-btn a-btn--primary a-btn--search-list ">Tìm
                                    kiếm</Button>
                            </div>
                        </Col>
                    </Form>
                </Row>
            </div>
        )
    }
}
export default FormSearch;